import Vue from 'vue';

export default {
  SET_CLIENTS: (state, response) => {
    Vue.set(state, 'clients', response);
  },
  SET_ALL_CONTRACTS: (state, contracts) => {
    Vue.set(state, 'allContracts', contracts);
  },
  SET_FILTERED_CLIENTS: (state, response) => {
    Vue.set(state, 'filtered_clients', response.clients);
    Vue.set(state, 'filtered_clients_count', response.clients_count);
  },
  DELETE_CLIENT: (state, data) => {
    for (let i = 0; i < state.filtered_clients.length; i++) {
      if (state.filtered_clients[i].id == data.id) {
        state.deleted_client = {
          data: state.filtered_clients[i],
          message: data.message,
          status: 'success'
        };
        state.filtered_clients.splice(i, 1);
      }
    }
  },
  UPDATE_CLIENT: (state, response) => {
    for (let i = 0; i < state.filtered_clients.length; i++) {
      if (state.filtered_clients[i].id == response.data.id) {
        state.client_updated = {
          data: response.data,
          message: response.message,
          status: 'success'
        };
        state.filtered_clients[i] = response.data;
      }
    }
  },
  SAVE_VARIABLES: (state, response) => {

  },
  SET_CONTRACTS: (state, response) => {
    // response.contracts.sort(function(a,b) {return (a.contract_date < b.contract_date) ? 1 : ((b.contract_date < a.contract_date) ? -1 : 0);} );
    for (let i = 0; i < response.contracts.length; i++) {
      response.contracts[i].contract_status = response.contracts[i].contract_status.charAt(0).toUpperCase() + response.contracts[i].contract_status.slice(1);
      response.contracts[i].contract_status = response.contracts[i].contract_status.split('_').join(' ');
      response.contracts[i].document_type = response.contracts[i].document_type.charAt(0).toUpperCase() + response.contracts[i].document_type.slice(1);
      response.contracts[i].document_type = response.contracts[i].document_type.split('_').join(' ');
    }
    Vue.set(state, 'contracts', response.contracts);
    Vue.set(state, 'contracts_count', response.contracts_count);
  },
  DELETE_CONTRACT: (state, data) => {
    if (state.contracts.length) {
      for (let i = 0; i < state.contracts.length; i++) {
        if (state.contracts[i].id == data.id) {
          state.deleted_contract = {
            data: state.contracts[i],
            message: data.message,
            status: 'success'
          };
          state.contracts.splice(i, 1);
        }
      }
    } else {
      state.deleted_contract = {
        data: data,
        message: data.message,
        status: 'success'
      };
    }
  },
  ADD_CONTRACT: (state, response) => {
    state.contracts.unshift(response.data);
    state.copied_contract = {
      data: response.data,
      message: '',
      status: 'success'
    };
  },
  ERROR_UPDATE_CLIENT: (state, errors) => {
    state.client_updated = {
      data: {},
      message: errors.message,
      status: 'error'
    };
  },
  ERROR_DELETE_CONTRACT: (state, response) => {
    state.deleted_contract = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
  ERROR_DELETE_CLIENT: (state, response) => {
    state.deleted_client = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
  ERROR_COPY_CONTRACT: (state, response) => {
    state.copied_contract = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
  ERROR_DELETE_FILE: (state, response) => {
    state.deleted_file = {
      data: {},
      message: response.message,
      status: 'error'
    };
  },
  DELETE_FILE: (state, response) => {
    state.deleted_file = {
      data: response.id,
      message: response.message,
      status: 'success'
    };
  },
  SET_INVOICES: (state, response) => {
    const invoices = {};
    response.data.forEach((invoice) => {
      invoices[invoice.invoice_id] = invoice;
    });
    Vue.set(state, 'invoices', invoices);
  },
  SET_INVOICE: (state, response) => {
    Vue.set(state.invoices, response.data.invoice_id, response.data);
  },
  SET_LAST_INVOICE: (state, response) => {
    Vue.set(state, 'last_invoice', response);
  }
};
